import { useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { useEntity } from '@backstage/plugin-catalog-react';

import { AirflowPipelineCard } from './AirflowPipelineCard';
import { DeletePipelineDialog } from './DeletePipelineDialog';
import { EditPipelineDialog } from './EditPipelineDialog';
import { PromoteToProdButton } from './PromoteToProdButton';

/**
 * 파이프라인 엔티티 페이지 본문.
 *
 * `EntityPage.tsx` 의 `pipelineEntityPage` 에 흩어져 있던 카드·버튼을 모았다.
 * 이전에는 버튼 2개가 `EntityPage.tsx` 안에 인라인 정의되어 있었고,
 * `/create/templates/default/sql-pipeline-{update,delete}-template?formData=...`
 * 로 **페이지를 이동**시켰다. 이제 같은 페이지에서 다이얼로그가 열린다.
 */
export const PipelineEntityContent = () => {
  const { entity } = useEntity();
  const pipelineName = entity.metadata.name;
  const [editing, setEditing] = useState(false);
  const [deleting, setDeleting] = useState(false);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <AirflowPipelineCard env="dev" />
      </Grid>
      <Grid item xs={12}>
        <AirflowPipelineCard env="prod" />
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" style={{ gap: 8 }}>
          <PromoteToProdButton />
          <Button
            variant="outlined"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => setEditing(true)}
          >
            파이프라인 수정
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<DeleteOutlineIcon />}
            onClick={() => setDeleting(true)}
          >
            파이프라인 삭제
          </Button>
        </Box>
      </Grid>

      <EditPipelineDialog
        pipelineName={pipelineName}
        open={editing}
        onClose={() => setEditing(false)}
      />
      <DeletePipelineDialog
        pipelineName={pipelineName}
        open={deleting}
        onClose={() => setDeleting(false)}
      />
    </Grid>
  );
};
